import { render, staticRenderFns } from "./ChildrenWrapper.vue?vue&type=template&id=4c1b6c0c&"
import script from "./ChildrenWrapper.vue?vue&type=script&lang=js&"
export * from "./ChildrenWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenWrapper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports